import { render, staticRenderFns } from "./SettingsColorPicker.vue?vue&type=template&id=d9241340&"
import script from "./SettingsColorPicker.vue?vue&type=script&lang=js&"
export * from "./SettingsColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9241340')) {
      api.createRecord('d9241340', component.options)
    } else {
      api.reload('d9241340', component.options)
    }
    module.hot.accept("./SettingsColorPicker.vue?vue&type=template&id=d9241340&", function () {
      api.rerender('d9241340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsColorPicker.vue"
export default component.exports